// frontend/src/marketing/PublicFooter.jsx
import React from "react";
import { Link } from "react-router-dom";
import { FOOTER_COLUMNS } from "./navConfig";
import { Container, Badge } from "./ui";
import Logo from "./Logo";

const YEAR = new Date().getFullYear();

export default function PublicFooter() {
  return (
    <footer className="border-t border-gray-200 bg-white">
      <Container className="py-14">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-6">
          <div className="col-span-2 md:col-span-1">
            <Logo className="h-8" />
            <p className="mt-4 max-w-xs text-sm text-gray-500">
              Dynamic QR codes with privacy-first, real-time analytics.
            </p>
          </div>
          {FOOTER_COLUMNS.map((col) => (
            <div key={col.title}>
              <h3 className="text-sm font-semibold text-gray-900">{col.title}</h3>
              <ul className="mt-4 space-y-3">
                {col.links.map((l) => (
                  <li key={l.to}>
                    <Link to={l.to} className="text-sm text-gray-500 hover:text-brand-700">
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-gray-200 pt-8 sm:flex-row">
          <p className="text-xs text-gray-500">© {YEAR} QRFlow. All rights reserved.</p>
          <div className="flex items-center gap-2">
            <Badge tone="gray">GDPR-ready</Badge>
            <Badge tone="gray">No raw IPs stored</Badge>
          </div>
        </div>
      </Container>
    </footer>
  );
}
